import { fetchSessionsClip } from '../common/api/sessions';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';

/** @prettier */

export const FETCH_SESSIONS_CLIP = 'FETCH_SESSIONS_CLIP';
export const FETCH_SESSIONS_CLIP_SUCCESS = 'FETCH_SESSIONS_CLIP_SUCCESS';
export const FETCH_SESSIONS_CLIP_FAILURE = 'FETCH_SESSIONS_CLIP_FAILURE';

export const getSessionsClip = (clipId, cookies, clientIp) => async (dispatch) => {
  dispatch({
    type: FETCH_SESSIONS_CLIP,
  });

  try {
    const session = await fetchSessionsClip(clipId, cookies, clientIp);
    dispatch({
      type: FETCH_SESSIONS_CLIP_SUCCESS,
      session,
    });
  } catch (err) {
    if (400 <= err.statusCode && err.statusCode < 500) {
      dispatch({
        type: NOT_FOUND,
        message: 'The Session Clip Could not be found',
      });
    } else {
      dispatch({
        type: INTERNAL_SERVER_ERROR,
        message: 'The server could not return the Session Clip',
      });
    }
  }
};
